import Vue from 'vue';
import Vuex from 'vuex';

import auth from './modules/auth';
import user from './modules/user';
import error from './modules/error';
import organization from './modules/organization';
import language from './modules/language';
import digiRegman from './modules/digiRegman';
import eventRegistration from './modules/eventRegistration';

import root from './modules/root';

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		auth,
		user,
		error,
		organization,
		language,
		root,
		digiRegman,
		eventRegistration,
	},
});
